import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { injectIntl, defineMessages } from 'react-intl';

import * as common from 'libs/commonFunc';
import { Button, ModalTemplate, Loading } from 'components';
import { Message, List } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ConfigLDAP.css';
const cx = classNames.bind(styles);

class ConfigLDAP extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isModal, onProgress } = this.props;
    const { onToggleModal, connLDAP, LDAPConnectResult } = this.props;
    const rd = LDAPConnectResult['resultData'];
    const isReseult = LDAPConnectResult['isReseult'];
    let connectReseult = '';
    if (isReseult === 2) {
      // 연동 실패
      if (!!rd['noService']) {
        connectReseult = (
          <div className={cx('text-align-center')}>
            {defineMessages(
              formatMessage({
                id: 'ConfigLDAP_12',
                defaultMessage: '존재하지 않는 ServiceNo 입니다.'
              })
            )}
            <br />
            {defineMessages(
              formatMessage({
                id: 'ConfigLDAP_14',
                defaultMessage: '확인 후 다시 시도해주세요.'
              })
            )}
          </div>
        );
      } else if (!!rd['noConnect'] || !!rd['noModule']) {
        connectReseult = (
          <div className={cx('text-align-center')}>
            {defineMessages(
              formatMessage({
                id: 'ConfigLDAP_13',
                defaultMessage: '입력하신 LDAP 연동 정보가 올바르지 않습니다.'
              })
            )}
            <br />
            {defineMessages(
              formatMessage({
                id: 'ConfigLDAP_14',
                defaultMessage: '확인 후 다시 시도해주세요.'
              })
            )}
          </div>
        );
      }
    } else {
      // 연동 성공
      connectReseult = (
        <div>
          {defineMessages(
            formatMessage({
              id: 'ConfigLDAP_11',
              defaultMessage: 'LDAP 수동 연동 결과'
            })
          )}
        </div>
      );
    }

    return (
      <div className={cx('ldap-wrap')}>
        {!!isModal && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className={cx('modal-admin tiny', 'common-content', 'ldap-modal')}
            visible
            onToggleModal={onToggleModal}
            header={
              <div>{defineMessages(formatMessage({ id: 'ConfigLDAP_1', defaultMessage: 'LDAP 수동 연동' }))}</div>
            }
            buttons={
              <div className={cx('inline-block')}>
                <Button
                  buttonColor="#bbbbbb"
                  onClick={() => {
                    onToggleModal(false);
                  }}>
                  {defineMessages(formatMessage({ id: 'StartExamWizardButton_4', defaultMessage: '확 인' }))}
                </Button>
              </div>
            }>
            <Loading active={onProgress} size="small" content="Waiting..." />
            <div className={cx('message-header')}>{connectReseult}</div>
            {isReseult === 1 && (
              <Message className={cx('template-detail-box')}>
                <div className={cx('template-detail')}>
                  <List bulleted className={cx('template-detail-list')}>
                    {!!rd['serviceNo'] && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_7', defaultMessage: '서비스No' }))}
                        </div>
                        {rd['serviceNo']}
                      </List.Item>
                    )}
                    {!!rd['serviceName'] && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_8', defaultMessage: '서비스명' }))}
                        </div>
                        {rd['serviceName']}
                      </List.Item>
                    )}
                    {!!rd['serviceOwner'] && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_9', defaultMessage: '사용자' }))}
                        </div>
                        {rd['serviceOwner']}
                      </List.Item>
                    )}
                    {!!rd['regDate'] && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_10', defaultMessage: '등록일시' }))}
                        </div>
                        {rd['regDate']}
                      </List.Item>
                    )}
                    {rd['alreadyExist'] > 0 && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_2', defaultMessage: '유지 대상자' }))}
                        </div>
                        {rd['alreadyExist']}명
                      </List.Item>
                    )}
                    {rd['addCount'] > 0 && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_3', defaultMessage: '추가 대상자' }))}
                        </div>
                        {rd['addCount']}명
                      </List.Item>
                    )}
                    {rd['editCount'] > 0 && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_4', defaultMessage: '변경 대상자' }))}
                        </div>
                        {rd['editCount']}명
                      </List.Item>
                    )}
                    {rd['deleteCount'] > 0 && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_5', defaultMessage: '삭제 대상자' }))}
                        </div>
                        {rd['deleteCount']}명
                      </List.Item>
                    )}
                    {rd['errorCount'] > 0 && (
                      <List.Item className={cx('template-detail-item')}>
                        <div className={cx('template-detail-item-title')}>
                          {defineMessages(formatMessage({ id: 'ConfigLDAP_6', defaultMessage: '실패 대상자' }))}
                        </div>
                        {rd['errorCount']}명
                      </List.Item>
                    )}
                  </List>
                </div>
              </Message>
            )}
          </ModalTemplate>
        )}
        <div className={cx('config-class', 'bt-conn-box')}>
          <div className={cx('bt-conn-area')}>
            <Button
              className={cx('bt-style-gleam', 'common-button-brand')}
              size="small"
              loading={onProgress}
              disabled={onProgress}
              content={defineMessages(formatMessage({ id: 'ConfigLDAP_1', defaultMessage: 'LDAP 수동 연동' }))}
              onClick={connLDAP}
            />
          </div>
        </div>
      </div>
    );
  }
}

ConfigLDAP.propTypes = {
  paramOptions: PropTypes.object
};
ConfigLDAP.defaultProps = {
  paramOptions: {}
};

export default injectIntl(ConfigLDAP);



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigLDAP.js